import '../styles/Footer.css'
import github_logo from '../assets/github.svg'
import linkedin_logo from '../assets/linkedin.svg'
import mail_logo from '../assets/mail.svg'
import Animation from './Animation'


export default function Footer() {
    return(
        <div className="footer" id='contact'>
            <div className='footer__title'>
                <h1>
                    Let's work <span className='footer__together'>together.</span>
                </h1>
            </div>
            <div className='footer__contact'>
                <div>
                    <Animation/>
                </div>
                <span className='line'></span>
                <div className='footer__logos'>
                    <h1>Contact me</h1>
                    <a href='https://linkedin.com/in/alexuscr27' target="_blank" rel="noopener noreferrer">
                        <img src={linkedin_logo} alt='github logo'/>  linkedin.com/in/alexuscr27/
                    </a>
                    <a href='https://github.com/ALEXUSCR-27' target="_blank" rel="noopener noreferrer">
                        <img src={github_logo} alt='github logo'/> github.com/ALEXUSCR-27
                    </a>

                    <a href='mailto:asmalexander@hotmail.com'>
                        <img src={mail_logo} alt='github logo'/> asmalexander@hotmail.com
                    </a>
                </div>
            </div>
            <div className='footer__author'>
                <div className='footer__author_name'>
                    <h3>
                        © ALEXANDER SÁNCHEZ CÉSPEDES  
                    </h3>
                </div>
            </div>
        </div>
    )
}